import type { Testimonial } from '../testimonials'

/**
 * Fethi Baytan, under Aktek's mark: the technology hub that carries Akkök
 * Holding's roadmaps into delivery. The second of the two quotes the Akkök story
 * page closes on — see `content/stories/akkok-holding.ts`.
 */
export const added: Testimonial = {
  company: 'Aktek',
  logo: { name: 'Aktek', src: '/logo/aktekcard.png' },
  portrait: { src: '/photo/portrait-fethi-baytan.png', alt: 'Fethi Baytan' },
  quote: [
    'The assessment gave us a clear, comparable view across the companies we support. That '
    + 'makes it easier to agree on priorities, put initiatives in the right order and carry '
    + 'the roadmaps into delivery.',
  ],
  attribution: 'Fethi Baytan, CIO, Akkök Holding – General Manager, Aktek',
  story: 'akkok-holding',
}
